A code describing the severity of the not posted reason.

This could be either "error", "warning", or "info".
